import axios from 'axios';

/**
 * Sunucu/ag hatasini KULLANICIYA GOSTERILEBILIR bir mesaja cevirir.
 *
 * Uc ayri kaynak var ve ucu de farkli davranir:
 *   1. HTTP 401/400 + zarf mesaji  -> sunucu zaten Turkce ve kullaniciya donuk
 *      bir mesaj yaziyor ("E-posta veya şifre hatalı"). Onun uzerine kendi
 *      metnimizi yazmak, sunucunun soyledigini gizler.
 *   2. HTTP 429                    -> ag gecidi oran siniri (girisde IP basina
 *      10, e-posta basina 5 / 15 dk). Sunucu govdesi bos gelebilir; kullanicinin
 *      "sifremi mi unuttum" diye dusunmemesi icin ozel mesaj SART.
 *   3. Yanit YOK                   -> baglanti kurulamadi. "Bir sorun olustu"
 *      demek burada yaniltici: sorun kimlik bilgilerinde degil.
 */
export const authErrorMessage = (
  error: unknown,
  t: (key: string) => string,
): string => {
  if (axios.isAxiosError(error)) {
    if (!error.response) return t('auth.networkError');
    if (error.response.status === 429) return t('auth.tooManyAttempts');
    const data = error.response.data as { message?: unknown } | undefined;
    if (typeof data?.message === 'string' && data.message.trim().length > 0) {
      return data.message;
    }
    if (error.response.status === 401) return t('auth.invalidCredentials');
  }
  if (error instanceof Error && error.message.trim().length > 0) return error.message;
  return t('errors.generic');
};
